<template>
  <div class="modal fade select-image-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">
                            &times;
                        </span>
          </button>

          <h4 class="modal-title">
            Select Image
          </h4>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="btn btn-default btn-block" :class="{'active': mode === 'existing'}"
                   @click="mode = 'existing'">
                Select Existing
              </div>
            </div>

            <div class="col-xs-12">
              <div class="btn btn-default btn-block" :class="{'active': mode === 'new'}"
                   @click="mode = 'new'">
                Upload New
              </div>
            </div>
          </div>

          <hr>

          <div v-if="mode === 'existing'">
            <form @submit.prevent="submitSearch" style="margin-bottom: 14px">
              <div class="input-group">
                <input v-model="currentSearch" type="text" class="form-control"
                       placeholder="Search images">

                <span class="input-group-btn">
                                <button class="btn btn-black" type="submit"><i class="fa fa-search"/> Search</button>
                            </span>
              </div>
            </form>

            <loading-spinner v-if="loading"/>

            <div v-else>
              <div v-for="chunk in chunks" class="row" style="margin-bottom: 14px">
                <div v-for="image in chunk" class="col-xs-6">
                  <div style="position: relative; cursor: pointer;" @click="select(image)">
                    <img
                        :src="'/images/crop-400x400/' + image.id + '.' + image.attributes.extension"
                        style="width: 100%"
                    >

                    <div
                        style="position: absolute; top: 0; left: 0; background-color: #000000; opacity: 0.7; width: 100%; color: #ffffff; padding: 4px; font-size: 12px">
                      {{ image.attributes.title }}
                    </div>
                  </div>
                </div>
              </div>

              <simple-pager :current-page="page" :last-page="images.meta.last_page" @navigate="navigate"/>
            </div>
          </div>

          <form @submit.prevent="submit" v-if="mode === 'new'">
            <text-form-group
                v-model="data.title"
                name="title"
                label="Title"
                :error="getError('title')"
                style="margin-right: 0; margin-left: 0"
            />

            <text-form-group
                v-model="data.credit"
                name="credit"
                label="Credit"
                :error="getError('credit')"
                style="margin-right: 0; margin-left: 0"
            />

            <text-form-group
                v-model="data.alt"
                name="alt"
                label="Alt"
                :error="getError('alt')"
                style="margin-right: 0; margin-left: 0"
            />

            <form-group name="file" label="File" :error="getError('file')" style="margin-right: 0; margin-left: 0">
              <input
                  v-if="uploadReady"
                  type="file"
                  class="form-control"
                  id="file"
                  @change="data.file = $event.target.files[0]"
              >
            </form-group>

            <submit-form-group style="margin-right: 0; margin-left: 0" button-class="btn-black"/>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SimplePager from '@/components/Lists/SimplePager'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {FormGroup, SimplePager, LoadingSpinner, SubmitFormGroup, TextFormGroup},

  mixins: [Errors],

  props: {
    companyId: {
      required: false,
      type: [String, Number],
      default: null
    },
  },

  data() {
    return {
      images: null,

      loading: true,

      mode: 'existing',
      search: '',
      currentSearch: '',
      page: 1,

      data: {},
      uploadReady: true,
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  computed: {
    chunks() {
      let result = []

      for (let i = 0; i < this.images.data.length; i += 4) {
        result.push(this.images.data.slice(i, i + 4))
      }

      return result
    }
  },

  methods: {
    load() {
      http.get('/api/v2/images', {
        page_size: 12,
        page: this.page,
        'filter[search]': this.search,
        'filter[company_id]': this.companyId
      })
          .then(response => {
            this.images = response.data

            this.loading = false
          })
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    select(image) {
      this.$emit('select', image)

      $(this.$el).modal('hide')
    },

    submitSearch() {
      this.search = this.currentSearch

      this.navigate(1)
    },

    navigate(page) {
      this.page = page

      this.load()
    },

    reset() {
      this.mode = 'existing'

      this.page = 1

      this.search = ''

      this.currentSearch = ''

      this.errors = {}

      this.uploadReady = false

      this.$nextTick(() => {
        this.uploadReady = true
      })

      this.data = {}

      this.load()
    },

    submit() {
      http.post('/api/v2/images', this.getFormData())
          .then(response => {
            notify.success('The image was uploaded')

            this.select(response.data.data)
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    getFormData() {
      let formData = new FormData()

      formData.append('title', this.data.title || '')
      formData.append('credit', this.data.credit || '')
      formData.append('alt', this.data.alt || '')
      formData.append('file', this.data.file)
      formData.append('company_id', this.companyId || '')

      return formData
    }
  }
}
</script>
